import { Component, TemplateRef } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'pt-custom-renderer',
  template: `
    <ng-container
      *ngTemplateOutlet='template; context: templateContext'
    ></ng-container>
  `,
  styles: [``]
})
export class CustomRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  template: TemplateRef<unknown>;
  templateContext: { $implicit: any, params: any };

  refresh(params: unknown): boolean {
    this.templateContext = {
      $implicit: this.buildCellData(params),
      params
    };
    return true;
  }

  agInit(params: any): void {
    this.template = params['ngTemplate'.toString()];
    this.refresh(params);
  }


  buildCellData(params: any): AgGridTemplateRendererCellInfo {

    if (params.data) {
      return {
        row: params.data,
        fieldKey: params.colDef,
        rowIndex: params.rowIndex,
        fieldValue: params.data[params.colDef?.field]
      };
    } else if (params.column) { // used to handle also custom header cell component (IHeaderAngularComp)
      const fieldType = params['fieldType'.toString()];
      const fieldId = params['fieldId'.toString()];
      const fieldName = params['fieldName'.toString()];
      return {row: {...params, fieldType, fieldId, fieldName}};
    } else {
      return null;
    }
  }
}

export interface AgGridTemplateRendererCellInfo {
  row: any;
  rowIndex?: number;
  fieldKey?: string;
  fieldValue?: any;
}
